module.exports = __webpack_public_path__ + "static/lwcpng-60d040a9a26e2a72375ddb1eaefeeb57.png";